import appConfig from "configs/app.config";
import { invokeOmsService, queryOmsService } from "./apiService";
import { buildQueryParams } from "../utils/helper";
import { authStore } from "auth/authStore";

const getAdminRecordTypes = async ({
  pageNumber = 1,
  perPage = 10,
  sortBy = "description",
  orderBy = "ASC",
  search = "",
}) => {
  const queryParams = new URLSearchParams();

  if (pageNumber != null) queryParams.append("pageNumber", pageNumber);
  if (perPage != null) queryParams.append("perPage", perPage);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (orderBy) queryParams.append("orderBy", orderBy);
  if (search) queryParams.append("search", search);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getAdminRecordTypes}?${queryParams.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getAdminRequestTypes = async ({
  pageNumber = 1,
  perPage = 10,
  sortBy = "description",
  orderBy = "ASC",
  search = "",
}) => {
  const queryParams = new URLSearchParams();

  if (pageNumber != null) queryParams.append("pageNumber", pageNumber);
  if (perPage != null) queryParams.append("perPage", perPage);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (orderBy) queryParams.append("orderBy", orderBy);
  if (search) queryParams.append("search", search);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getAdminRequestTypes}?${queryParams.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

// const getAdminServices = async () => {
//   const requestParams = {
//     method: "GET",
//     url: appConfig.v2.getAdminServices,
//   };
//   return await invokeOmsService(requestParams);
// };

const getAdminServices = async ({
  pageNumber = 1,
  perPage = 10,
  sortBy = "createdAt",
  orderBy = "ASC",
  search = "",
}) => {
  const queryParams = new URLSearchParams();

  if (pageNumber != null) queryParams.append("pageNumber", pageNumber);
  if (perPage != null) queryParams.append("perPage", perPage);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (orderBy) queryParams.append("orderBy", orderBy);
  if (search) queryParams.append("search", search);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getAdminServices}?${queryParams.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

// const getAdminServiceMapping = async () => {
//   const requestParams = {
//     method: "GET",
//     url: appConfig.v2.getAdminServiceMapping,
//   };
//   return await invokeOmsService(requestParams);
// };

const getAdminServiceMapping = async ({
  pageNumber = 1,
  perPage = 10,
  sortBy = "createdAt",
  orderBy = "ASC",
  search = "",
}) => {
  const queryParams = new URLSearchParams();

  if (pageNumber != null) queryParams.append("pageNumber", pageNumber);
  if (perPage != null) queryParams.append("perPage", perPage);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (orderBy) queryParams.append("orderBy", orderBy);
  if (search) queryParams.append("search", search);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getAdminServiceMapping}?${queryParams.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getAdminProfileById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminProfileById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getParentService = async ({
  pageNumber,
  perPage,
  recordTypeId,
  requestTypeId,
  searach,
}) => {
  const params = new URLSearchParams();

  if (pageNumber !== undefined) params.append("pageNumber", pageNumber);
  if (perPage !== undefined) params.append("perPage", perPage);
  if (recordTypeId !== undefined) params.append("recordTypeId", recordTypeId);
  if (requestTypeId !== undefined)
    params.append("requestTypeId", requestTypeId);
  if (searach !== undefined && searach !== "") params.append("search", searach);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getParentServices}?${params.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getAdminCompanyList = async ({
  nature,
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  let url =
    appConfig.v2.getAdminCompanyList.replace("{nature}", nature) +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getAdminBodyParts = async ({
  pageNumber = 1,
  perPage = 10,
  sortBy = "name",
  orderBy = "ASC",
  search = "",
}) => {
  const queryParams = new URLSearchParams();

  if (pageNumber != null) queryParams.append("pageNumber", pageNumber);
  if (perPage != null) queryParams.append("perPage", perPage);
  if (sortBy) queryParams.append("sortBy", sortBy);
  if (orderBy) queryParams.append("orderBy", orderBy);
  if (search) queryParams.append("search", search);

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.getAdminBodyParts}?${queryParams.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const getAdminConfig = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminConfig,
  };
  return await invokeOmsService(requestParams);
};

const DEFAULT_ADMIN_REMINDER_ID = 1;

const getAdminReminder = async (id = DEFAULT_ADMIN_REMINDER_ID) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminReminder.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const createAdminReminder = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.createAdminReminder,
    body,
  };
  return await invokeOmsService(requestParams);
};

const updateAdminReminder = async (id = DEFAULT_ADMIN_REMINDER_ID, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateAdminReminder.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};
const getOrganizationsbyNature = async ({
  nature,
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  let url =
    appConfig.v2.getorganizationsbyNature.replace("{nature}", nature) +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getAccountsbyNature = async ({
  nature,
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  let url =
    appConfig.v2.getAccountsbyNature.replace("{nature}", nature) +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getAllAccounts = async ({
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  let url =
    appConfig.v2.getAllAccounts.replace() +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getUserLogs = async ({
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  let url =
    appConfig.v2.getUserLogs.replace() +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await queryOmsService(requestParams);
};

const getAuditLogs = async ({
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
  date,
  type,
  action,
}) => {
  let url =
    appConfig.v2.getAuditLogs +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;

  if (date) url += `&date=${date}`;
  if (type) url += `&type=${type}`;
  if (action) url += `&action=${action}`;

  const requestParams = {
    method: "GET",
    url,
  };

  return await queryOmsService(requestParams);
};

const getAdminActivities = async ({
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
  date,
  fromDate,
  toDate,
  primaryAction,
  primaryActions,
  subAction,
  subActions,
}) => {
  const resolvedFromDate = fromDate || date;
  const resolvedToDate = toDate || date;

  let url =
    appConfig.v2.getAdminActivities +
    `?pageNumber=${pageIndex}` +
    `&perPage=${pageSize}` +
    `&sortBy=${sortBy}` +
    `&orderBy=${sortOrder}` +
    `&search=${encodeURIComponent(search ?? "")}`;

  if (resolvedFromDate) {
    url += `&fromDate=${encodeURIComponent(resolvedFromDate)}`;
  }

  if (resolvedToDate) {
    url += `&toDate=${encodeURIComponent(resolvedToDate)}`;
  }

  if (date) {
    url += `&date=${encodeURIComponent(date)}`;
  }

  if (primaryAction) {
    url += `&primaryAction=${encodeURIComponent(primaryAction)}`;
  }

  if (Array.isArray(primaryActions)) {
    primaryActions.forEach((actionType) => {
      url += `&primaryAction=${encodeURIComponent(actionType)}`;
    });
  }

  if (subAction) {
    url += `&subAction=${encodeURIComponent(subAction)}`;
  }

  if (Array.isArray(subActions)) {
    subActions.forEach((actionName) => {
      url += `&subAction=${encodeURIComponent(actionName)}`;
    });
  }

  return await queryOmsService({
    method: "GET",
    url,
  });
};

const getAllPatient = async ({
  nature,
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
}) => {
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getAllPatient +
      `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`,
  };
  return await invokeOmsService(requestParams);
};

const getUsers = async (data) => {
  const { perPage, pageNumber, sortBy, sortOrder, search } = data;
  let url =
    appConfig.v2.getAdminUsers +
    `?pageNumber=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await invokeOmsService(requestParams);
};

const getPendingFacilities = (data) => {
  const { pageIndex, pageSize, sortBy, sortOrder, search, facilityTypeValue } =
    data;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getPendingFacilities.replace("{nature}", facilityTypeValue) +
      `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`,
  };
  return invokeOmsService(requestParams);
};

const updateAdminConfig = async (body, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateAdminConfig.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const adminRecordTypes = async (payload) => {
  const {
    pageNumber = 1,
    perPage = 10,
    sortBy = "createdAt",
    sortOrder = "DESC",
    nature = "",
    search = "",
    searchFields = "",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    nature,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  const url =
    appConfig.v2.adminRecordTypes +
    `?pageNumber=${pageNumber}` +
    `&perPage=${perPage}` +
    `&sortBy=${sortBy}` +
    `&orderBy=${sortOrder}` +
    `&nature=${encodeURIComponent(nature)}` +
    `&search=${encodeURIComponent(search)}` +
    `&searchFields=${encodeURIComponent(searchFields)}`;
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.adminRecordTypes}?${query.toString()}`,
  };

  return await invokeOmsService(requestParams);
};

const appendIsArchivedQuery = (query, isArchived) => {
  if (isArchived === true || isArchived === "true") {
    query.set("isArchived", "true");
  } else if (isArchived === false || isArchived === "false") {
    query.set("isArchived", "false");
  }
};

const appendIsActiveQuery = (query, isActive) => {
  if (isActive === true || isActive === "true") {
    query.set("isActive", "true");
  } else if (isActive === false || isActive === "false") {
    query.set("isActive", "false");
  }
};

const adminRequestTypes = async (payload) => {
  const {
    nature,
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  let url =
    appConfig.v2.adminRequestType +
    `?pageNumber=${pageNumber}&perPage=${perPage}` +
    `&sortBy=${sortBy}&orderBy=${sortOrder}` +
    `&search=${search ?? ""}` +
    `&searchFields=${searchFields ?? ""}`;
  if (nature) {
    query.set("nature", nature);
  }

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminRequestType}?${query.toString()}`,
  });
};

const adminFlowTypes = async (payload) => {
  const {
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminFlowType}?${query.toString()}`,
  });
};

const adminaddFlowType = async (payload) =>
  await invokeOmsService({
    method: "POST",
    url: appConfig.v2.adminaddFlowType,
    body: payload,
  });

const admineditFlowType = async (id, payload) =>
  await invokeOmsService({
    method: "PUT",
    url: appConfig.v2.admineditFlowType.replace("{id}", id),
    body: payload,
  });

const admingetFlowTypeById = async (id) =>
  await invokeOmsService({
    method: "GET",
    url: appConfig.v2.admingetFlowTypeById.replace("{id}", id),
  });

const adminServiceList = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
    usageType,
  } = payload;

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);
  // BASE | MODIFIER (admin_services.usage_type)
  if (usageType) query.set("usageType", usageType);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminServiceList}?${query.toString()}`,
  });
};

const adminServiceMapping = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
  } = payload;

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminServiceMapping}?${query.toString()}`,
  });
};

const adminXraybodypartsList = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search,
    searchFields,
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);
  let url =
    appConfig.v2.adminXraybodypartsList +
    `?pageNumber=${pageNumber}&perPage=${perPage}` +
    `&sortBy=${sortBy}&orderBy=${sortOrder}` +
    `&search=${search ?? ""}` +
    `&searchFields=${searchFields ?? ""}`;

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminXraybodypartsList}?${query.toString()}`,
  });
};

const adminXraybodypartsWithFeeList = async (payload = {}) => {
  const {
    pageNumber = 1,
    perPage = 10,
    search = "",
    searchFields = "",
    sortBy = "createdAt",
    sortOrder = "DESC",
    isArchived,
    isActive,
  } = payload || {};

  const query = new URLSearchParams({
    pageNumber: String(pageNumber),
    perPage: String(perPage),
    sortBy,
    orderBy: sortOrder,
    search: search != null ? String(search) : "",
    searchFields: searchFields != null ? String(searchFields) : "",
  });

  appendIsArchivedQuery(query, isArchived);
  appendIsActiveQuery(query, isActive);

  return await invokeOmsService({
    method: "GET",
    url: `${appConfig.v2.adminXraybodypartsWithFeeList}?${query.toString()}`,
  });
};

const isApproved = async (id, body) => {
  const requestParams = {
    method: "PATCH",
    url: appConfig.v2.adminApproved.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const isCanceled = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminAccountCanceled,
    body,
  };
  return await invokeOmsService(requestParams);
};

const addXrayBodyParts = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminaddXrayBodyParts,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getXrayBodyPartEnums = async (category) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getXrayBodyPartEnums + `?fieldName=${category}`,
  };
  return await invokeOmsService(requestParams);
};

const getXrayCategoriesEnums = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminXrayCategoriesEnums,
  };
  return await invokeOmsService(requestParams);
};

const adminCreateBackOffice = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminCreateBackOffice,
    body,
  };
  return await invokeOmsService(requestParams);
};

const adminCreateAddCompany = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminCreateAddCompany,
    body,
  };
  return await invokeOmsService(requestParams);
};

const adminCreateAddAttorney = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminCreateAddAttorney,
    body,
  };
  return await invokeOmsService(requestParams);
};

const adminCreateAddDoctorFacility = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminCreateAddDoctorFacility,
    body,
  };
  return await invokeOmsService(requestParams);
};

const editXrayBodyParts = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.editAdminXrayBodyParts.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getXrayBodyPartById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.admingetRequestTypeById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const adminaddServiceList = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminaddServiceList,
    body,
  };
  return await invokeOmsService(requestParams);
};

const admineditServiceList = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.admineditServiceList.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getServiceListById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminServiceListById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const admingetRequestTypeById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.admingetRequestTypeById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const admineditRequestType = async (bodyData, id) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.admineditRequestType.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const adminaddRequestType = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminaddRequestType,
    body,
  };
  return await invokeOmsService(requestParams);
};

const admingetRecordTypeById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.admingetRecordTypeById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const admineditRecordType = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.admineditRecordType.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const adminaddRecordType = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminaddRecordType,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getServiceMappingById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getadminServiceMappingById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const adminaddServiceMapping = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminaddServiceMapping,
    body,
  };
  return await invokeOmsService(requestParams);
};

const admineditServiceMapping = async (bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.admineditServiceMapping.replace("{id}", bodyData.id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const admindeleteServiceMapping = async (serviceFeeId) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.admindeleteServiceMapping.replace("{id}", serviceFeeId),
  };
  return await invokeOmsService(requestParams);
};

const getCannedMessages = async (payload = {}) => {
  const {
    pageNumber,
    perPage,
    search,
    searchFields,
    sortBy,
    sortOrder,
    isArchived = false,
    isActive,
    type = "",
  } = payload;

  let url =
    appConfig.v2.addAdminCannedMessage +
    `?pageNumber=${pageNumber}` +
    `&search=${search ?? ""}` +
    `&searchFields=${searchFields ?? ""}` +
    `&isArchived=${isArchived}` +
    `&isActive=${isActive}` +
    `&type=${type}`;

  return await invokeOmsService({
    method: "GET",
    url,
  });
};

const getCannedMessagesById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminCannedMessagesById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const addCannedMessage = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.addAdminCannedMessage,
    body,
  };
  return await invokeOmsService(requestParams);
};

const updateCannedMessage = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateAdminCannedMessage.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const admingetCompanyDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.admingetCompanyDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const updatePatientDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updatePatientDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getCompanyUserDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getCompanyUserDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const updateCompanyUserDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateCompanyUserDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const updateCompanyEmployee = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateCompanyEmployee.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const adminUpdateFacilityDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.adminUpdateFacilityDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const adminUpdateAccountDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.adminUpdateAccountDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const adminUpdateMedicalFacilityDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.adminUpdateMedicalFacilityDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const updateMedicalFacilityDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateMedicalFacilityDetails.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const login = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminLogin,
    body,
  };
  return await invokeOmsService(requestParams);
};
const generateAuthenticatorQR = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminGenerateAuthenticatorQR,
    body,
  };
  return await invokeOmsService(requestParams);
};

const setUpAuthenticatorDetails = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminSetUpAuthenticator,
    body,
  };
  return await invokeOmsService(requestParams);
};

const verifiedLogin = async () => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminVerifiedLogin,
    body: {},
  };
  return await invokeOmsService(requestParams);
};
const validateAuthenticator = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminValidateAuthenticator,
    body,
  };
  return await invokeOmsService(requestParams);
};

const verify2faRecoveryCode = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminVerify2faRecoveryCode,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getRejectedFacilities = (data) => {
  const { pageIndex, pageSize, sortBy, sortOrder, search, facilityTypeValue } =
    data;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getRejectedFacilities.replace(
        "{nature}",
        facilityTypeValue,
      ) +
      `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`,
  };
  return invokeOmsService(requestParams);
};

const getPendingSignUPFacilities = (data) => {
  const { pageIndex, pageSize, sortBy, sortOrder, search, facilityTypeValue } =
    data;
  const requestParams = {
    method: "GET",
    url:
      appConfig.v2.getPendingSignUPFacilities.replace(
        "{nature}",
        facilityTypeValue,
      ) +
      `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`,
  };
  return invokeOmsService(requestParams);
};

const getUserDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getUserDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getOrderDetails = async (requestId) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getOrderDetails.replace("{id}", requestId),
  };
  return await invokeOmsService(requestParams);
};

const getadminFacilityDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getadminFacilityDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getadminAccountDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getadminAccountDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getAdminEarningDetailsById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminEarningDetailsById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getadminMedicalFacilityDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getadminMedicalFacilityDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getadminLawOfficeDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getadminLawOfficeDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getMedicalFacilityDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getMedicalFacilityDetails.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getRolesByUserId = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getRolesByAdmin,
  };
  return await invokeOmsService(requestParams);
};

const makeIsOwner = async (body) => {
  const requestParams = {
    method: "PATCH",
    url: appConfig.v2.transferOwner,
    body,
  };
  return await invokeOmsService(requestParams);
};
const getAdminPendingRequestDetails = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.getAdminPendingRequestDetails.replace(
      "{id}",
      parseInt(id),
    ),
  };
  return await invokeOmsService(requestParams);
};
const updateAdminPendingRequestDetails = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateAdminPendingRequestDetails.replace(
      "{id}",
      parseInt(id),
    ),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const updateAccountAndUser = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateAccountAndUser.replace("{id}", parseInt(id)),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const AdminupdateProfile = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.AdminupdateProfile.replace("{id}", parseInt(id)),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const admingetXrayBodyPartById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.admingetXrayBodyPartById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};
const changePassword = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminChangePassword,
    body,
  };
  return await invokeOmsService(requestParams);
};

const forgotPassword = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminforgotPassword,
    body,
  };
  return await invokeOmsService(requestParams);
};

const resetPassword = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminResetPassword,
    body,
  };
  return await invokeOmsService(requestParams);
};

const verifyToken = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.adminVerifyToken,
    body,
  };
  return await invokeOmsService(requestParams);
};
const updateUserStatus = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateUserStatus.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};
const getAdminStatus = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.getAdminStatus.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const updateBackofficeStatus = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateBackofficeStatus.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const updateFacilityStatus = async (id, bodyData) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.updateFacilityStatus.replace("{id}", id),
    body: bodyData,
  };
  return await invokeOmsService(requestParams);
};

const getPendingFacilityCounts = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.accounts.getPendingFacilityCounts,
  };
  return await invokeOmsService(requestParams);
};

const getAdminPaymentTransactions = (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getAdminPaymentTransactions,
    body,
  };
  return invokeOmsService(requestParams);
};

const getAdminPaymentGatewayLog = (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getAdminPaymentTransactions,
    body,
  };
  return invokeOmsService(requestParams);
};

const archiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.archiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const requestTypeArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.requestTypeArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};
const recordTypeArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.recordTypeArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const serviceMappingArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.serviceMappingArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const serviceListArchiveData = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.serviceListArchiveData.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const resendVerifyAccountEmail = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.resendVerifyAccountEmail.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const getAllUsersByAccountId = async (data, accountId) => {
  const { perPage, pageNumber, sortBy, sortOrder, search } = data;

  let url =
    appConfig.v2.getAllUsersByAccountId.replace("{accountId}", accountId) +
    `?pageNumber=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${search}`;
  const requestParams = {
    method: "GET",
    url,
  };
  return await invokeOmsService(requestParams);
};

const nextAccount = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.nextAccount,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getNextFacilityAccount = async (type, requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getNextFacilityAccount.replace("{type}", type),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getPreviousFacilityAccount = async (type, requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getPreviousFacilityAccount.replace("{type}", type),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const nextAcc = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.nextAcc,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getNextAccount = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.getNextAccount,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const previousAccount = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.previousAccount,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const previousAcc = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.previousAcc,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getPreviousAccount = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.accounts.getPreviousAccount,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const getNextOrganization = async (type, requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getNextOrganization.replace("{type}", type),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};
const getPreviousOrganization = async (type, requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getPreviousOrganization.replace("{type}", type),
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};
export const getNextPendingRequest = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getNextPendingRequest,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

export const getPreviousPendingRequest = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getPreviousPendingRequest,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

export const getNextRejectRequest = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getNextRejectRequest,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

export const getPreviousRejectRequest = async (requestBody) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.getPreviousRejectRequest,
    body: requestBody,
  };
  return await invokeOmsService(requestParams);
};

const archiveAdminCannedMessage = async (id, body) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.archiveAdminCannedMessage.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};


const getAuthToken = () => authStore.getAccessToken();

const exportMasterDataCsv = async (entity) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Unauthorized");
  }
  const url =
    appConfig.api.domain +
    appConfig.v2.masterDataCsvExport.replace("{entity}", entity);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/csv",
    },
  });
  if (!response.ok) {
    const errBody = await response.json().catch(() => ({}));
    throw new Error(
      errBody?.message || errBody?.error || "Failed to export CSV",
    );
  }
  return await response.blob();
};

const downloadMasterDataCsvTemplate = async (entity) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error("Unauthorized");
  }
  const url =
    appConfig.api.domain +
    appConfig.v2.masterDataCsvTemplate.replace("{entity}", entity);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/csv",
    },
  });
  if (!response.ok) {
    const errBody = await response.json().catch(() => ({}));
    throw new Error(
      errBody?.message || errBody?.error || "Failed to download template",
    );
  }
  return await response.blob();
};

const importMasterDataCsv = async (entity, file) => {
  const formData = new FormData();
  formData.append("file", file, file?.name || "import.csv");

  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataCsvImport.replace("{entity}", entity),
    body: formData,
  };

  try {
    const response = await invokeOmsService(requestParams);
    return response?.data ?? response;
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const apiMessage = data?.message;
    const detail =
      (Array.isArray(apiMessage) ? apiMessage.join(", ") : apiMessage) ||
      data?.error ||
      data?.errorMessage ||
      (typeof data === "string" ? data : null) ||
      error?.message ||
      "Failed to import CSV";

    const statusText = status ? ` [HTTP ${status}]` : "";
    throw new Error(`${detail}${statusText}`);
  }
};

const listMasterDataReleases = async (params = {}) => {
  const query = buildQueryParams(params);
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.masterDataReleases}${query ? `?${query}` : ""}`,
  };
  return await invokeOmsService(requestParams);
};

const getMasterDataReleaseById = async (id) => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.masterDataReleaseById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const createMasterDataRelease = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataReleases,
    body,
  };
  return await invokeOmsService(requestParams);
};

const updateMasterDataRelease = async (id, body = {}) => {
  const requestParams = {
    method: "PUT",
    url: appConfig.v2.masterDataReleaseById.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const publishMasterDataRelease = async (id, body = {}) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataReleasePublish.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const archiveMasterDataRelease = async (id) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataReleaseArchive.replace("{id}", id),
    body: {},
  };
  return await invokeOmsService(requestParams);
};

const deleteMasterDataRelease = async (id) => {
  const requestParams = {
    method: "STRICT_DELETE",
    url: appConfig.v2.masterDataReleaseById.replace("{id}", id),
  };
  return await invokeOmsService(requestParams);
};

const listMasterDataReleaseTenants = async (id, params = {}) => {
  const query = buildQueryParams(params);
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.masterDataReleaseTenants.replace("{id}", id)}${query ? `?${query}` : ""
      }`,
  };
  return await invokeOmsService(requestParams);
};

const listMasterDataReleaseLogs = async (id, params = {}) => {
  const query = buildQueryParams(params);
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.masterDataReleaseLogs.replace("{id}", id)}${query ? `?${query}` : ""
      }`,
  };
  return await invokeOmsService(requestParams);
};

const pushImportedMasterData = async (body) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataReleasePushImported,
    body,
  };
  return await invokeOmsService(requestParams);
};

const getMasterDataPushableCatalog = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.masterDataReleasePushableCatalog,
  };
  return await invokeOmsService(requestParams);
};

const listPendingMasterDataReleases = async (params = {}) => {
  const query = buildQueryParams(params);
  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.masterDataReleasesPending}${query ? `?${query}` : ""}`,
  };
  return await invokeOmsService(requestParams);
};

const countPendingMasterDataReleases = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.masterDataReleasesPendingCount,
  };
  return await invokeOmsService(requestParams);
};

const pullMasterDataRelease = async (id, body = {}) => {
  const requestParams = {
    method: "POST",
    url: appConfig.v2.masterDataReleasePull.replace("{id}", id),
    body,
  };
  return await invokeOmsService(requestParams);
};

const getAllActivities = async ({
  pageSize,
  pageIndex,
  sortBy,
  sortOrder,
  search,
  date,
  fromDate,
  toDate,
  primaryAction,
  subAction,
}) => {
  const resolvedFromDate = fromDate || date;
  const resolvedToDate = toDate || date;

  let url =
    appConfig.v2.getAllActivities +
    `?pageNumber=${pageIndex}&perPage=${pageSize}&sortBy=${sortBy}&orderBy=${sortOrder}&search=${encodeURIComponent(search ?? "")}`;

  if (resolvedFromDate) {
    url += `&fromDate=${encodeURIComponent(resolvedFromDate)}`;
  }

  if (resolvedToDate) {
    url += `&toDate=${encodeURIComponent(resolvedToDate)}`;
  }

  if (date) {
    url += `&date=${encodeURIComponent(date)}`;
  }

  if (primaryAction) url += `&primaryAction=${encodeURIComponent(primaryAction)}`;
  if (subAction) url += `&subAction=${encodeURIComponent(subAction)}`;

  const requestParams = {
    method: "GET",
    url,
  };

  return await queryOmsService(requestParams);
};

const getAdminActivityLogs = async ({
  pageSize = 10,
  pageIndex = 1,
  sortBy,
  sortOrder,
  primaryAction,
  subAction,
  date,
} = {}) => {
  const safePageIndex = Number.parseInt(pageIndex, 10);
  const safePageSize = Number.parseInt(pageSize, 10);

  const query = buildQueryParams({
    pageIndex: Number.isInteger(safePageIndex) && safePageIndex > 0 ? safePageIndex : 1,
    pageSize: Number.isInteger(safePageSize) && safePageSize > 0 ? safePageSize : 10,
    sortBy,
    sortOrder,
    date,
    primaryAction,
    subAction,
  });

  const requestParams = {
    method: "GET",
    url: `${appConfig.v2.adminActivityLogs}${query ? `?${query}` : ""}`,
  };
  return await queryOmsService(requestParams);
};

const getAdminActivityLogFilters = async () => {
  const requestParams = {
    method: "GET",
    url: appConfig.v2.adminActivityLogFilters,
  };
  return await queryOmsService(requestParams);
};

const AdminService = {
  getAllActivities,
  getAdminActivityLogs,
  getAdminActivityLogFilters,
  archiveAdminCannedMessage,
  getNextAccount,
  getPreviousAccount,
  getPreviousFacilityAccount,
  getNextFacilityAccount,
  previousAcc,
  nextAcc,
  getNextRejectRequest,
  getPreviousRejectRequest,
  getNextPendingRequest,
  getPreviousPendingRequest,
  getPreviousOrganization,
  getNextOrganization,
  previousAccount,
  nextAccount,
  getAllUsersByAccountId,
  serviceMappingArchiveData,
  recordTypeArchiveData,
  requestTypeArchiveData,
  archiveData,
  getAdminPaymentTransactions,
  getAdminPaymentGatewayLog,
  updateBackofficeStatus,
  updateFacilityStatus,
  getAdminRecordTypes,
  getAdminRequestTypes,
  getAdminServices,
  getAdminServiceMapping,
  getAdminBodyParts,
  getAdminConfig,
  getAdminReminder,
  createAdminReminder,
  updateAdminReminder,
  login,
  getOrganizationsbyNature,
  getAccountsbyNature,
  getAllPatient,
  getUsers,
  getPendingFacilities,
  getXrayBodyPartEnums,
  updateAdminConfig,
  exportMasterDataCsv,
  downloadMasterDataCsvTemplate,
  importMasterDataCsv,
  listMasterDataReleases,
  getMasterDataReleaseById,
  createMasterDataRelease,
  updateMasterDataRelease,
  publishMasterDataRelease,
  archiveMasterDataRelease,
  deleteMasterDataRelease,
  listMasterDataReleaseTenants,
  listMasterDataReleaseLogs,
  pushImportedMasterData,
  getMasterDataPushableCatalog,
  listPendingMasterDataReleases,
  countPendingMasterDataReleases,
  pullMasterDataRelease,
  adminRecordTypes,
  adminRequestTypes,
  adminFlowTypes,
  adminaddFlowType,
  admineditFlowType,
  admingetFlowTypeById,
  adminServiceList,
  adminServiceMapping,
  getParentService,
  adminXraybodypartsList,
  adminXraybodypartsWithFeeList,
  addXrayBodyParts,
  editXrayBodyParts,
  getXrayBodyPartById,
  adminaddServiceList,
  admineditServiceList,
  admingetXrayBodyPartById,
  getServiceListById,
  admingetRequestTypeById,
  admineditRequestType,
  adminaddRequestType,
  admingetRecordTypeById,
  admineditRecordType,
  adminaddRecordType,
  getServiceMappingById,
  adminaddServiceMapping,
  admineditServiceMapping,
  admindeleteServiceMapping,
  getadminAccountDetails,
  getAdminEarningDetailsById,
  adminUpdateAccountDetails,
  getCannedMessages,
  getCannedMessagesById,
  addCannedMessage,
  updateCannedMessage,
  adminCreateBackOffice,
  adminCreateAddCompany,
  adminCreateAddAttorney,
  adminCreateAddDoctorFacility,
  admingetCompanyDetails,
  getCompanyUserDetails,
  getXrayCategoriesEnums,
  updateCompanyUserDetails,
  updateCompanyEmployee,
  adminUpdateFacilityDetails,
  adminUpdateMedicalFacilityDetails,
  generateAuthenticatorQR,
  setUpAuthenticatorDetails,
  verifiedLogin,
  validateAuthenticator,
  verify2faRecoveryCode,
  isApproved,
  getRejectedFacilities,
  getAdminCompanyList,
  getUserDetails,
  getadminFacilityDetails,
  getadminMedicalFacilityDetails,
  getadminLawOfficeDetails,
  getRolesByUserId,
  getAllAccounts,
  makeIsOwner,
  getMedicalFacilityDetails,
  updateMedicalFacilityDetails,
  getAdminPendingRequestDetails,
  updateAdminPendingRequestDetails,
  changePassword,
  updatePatientDetails,
  getAdminProfileById,
  AdminupdateProfile,
  forgotPassword,
  resetPassword,
  verifyToken,
  updateUserStatus,
  getOrderDetails,
  getAdminStatus,
  getPendingFacilityCounts,
  serviceListArchiveData,
  getUserLogs,
  isCanceled,
  getPendingSignUPFacilities,
  resendVerifyAccountEmail,
  updateAccountAndUser,
  getAuditLogs,
  getAdminActivities
};
export default AdminService;
